<template>
    <b-row class="slide-body" >
            
        <b-col cols="1" v-if="$mq==='desktop'">
            <router-link :to="{name:'slide7',params:{lang:lang}}"><b-img left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img></router-link>
        </b-col>
        <b-col cols="1" v-else>
            <router-link :to="{name:'slide7',params:{lang:lang}}"><b-img left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img></router-link>
        </b-col>

        <b-col cols="10" v-if="$mq==='desktop'">               
            <b-row align-h="center" class="pb-5">   
                <h2 style="color:#ffffff"><strong>{{ $t('slide8.text1') }}</strong></h2>
            </b-row>
            <b-row align-h="center">                          
                <b-col cols="6"> 
                    <div class="contenedor">                
                        <b-img align="bottom" src="@/images/slide8-bubble-1.png" fluid></b-img>
                        <div class="texto-centrado">
                            <ul>
                                <li align="justify"><p><strong>{{ $t('slide8.text2') }}</strong></p></li>
                                <li align="justify"><p><strong>{{ $t('slide8.text3') }}</strong></p></li>
                                <li align="justify"><p><strong>{{ $t('slide8.text4') }}</strong></p></li>
                            </ul>
                            <p><strong>{{ $t('slide8.text5') }}</strong></p>
                        </div>                       
                    </div>
                </b-col>
                <b-col cols="6">                     
                    <b-img align="bottom" src="@/images/slide8-tronic.png" fluid></b-img>                                                       
                </b-col>                                 
            </b-row> 
            <b-row align-h="center" v-if="$mq==='desktop'">   
                <router-link :to="{name:'slide10',params:{lang:lang}}">
                    <b-button size="md" variant="warning">
                        <h2>
                            <strong>{{ $t('slide8.text6') }}</strong>
                        </h2>
                    </b-button>
                </router-link>
            </b-row>                            
        </b-col>
        <b-col cols="11" v-else>
            <b-row >  
                <b-row align-h="center" class="pt-3 pb-2">   
                    <h1 style="color:#ffffff"><strong>{{ $t('slide8.text1') }}</strong></h1>
                </b-row>
                <b-row align-h="center">                          
                    <b-col cols="7"> 
                        <div class="contenedor">                
                            <b-img align="bottom" src="@/images/slide8-bubble-1.png" fluid></b-img>
                            <div class="texto-centrado-else">
                                <ul>
                                    <li align="justify"><h5><strong>{{ $t('slide8.text2') }}</strong></h5></li>
                                    <li align="justify"><h5><strong>{{ $t('slide8.text3') }}</strong></h5></li>
                                    <li align="justify"><h5><strong>{{ $t('slide8.text4') }}</strong></h5></li>
                                </ul>
                                <h5><strong>{{ $t('slide8.text5') }}</strong></h5>
                            </div>                       
                        </div>
                    </b-col>
                    <b-col cols="5">                     
                        <b-img align="bottom" src="@/images/slide8-tronic-else.png" fluid></b-img>                                                       
                    </b-col>                                 
                </b-row> 
                <b-row align-h="center">
                    <b-col cols="7">
                    </b-col>
                    <b-col cols="5">   
                        <router-link :to="{name:'slide10',params:{lang:lang}}">
                            <b-button size="md" variant="warning">
                                <h2>
                                    <strong>{{ $t('slide8.text6') }}</strong>
                                </h2>
                            </b-button>
                        </router-link>
                    </b-col>
                </b-row>
            </b-row>           
        </b-col>

        <b-col cols="1" v-if="$mq==='desktop'">               
        </b-col>
    </b-row>  
    
</template>

<script>
import {mapState} from 'vuex';

export default {  
    props:['lang'],  
    computed: mapState(['showMenu']),
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
    },
    created(){
        this.$i18n.locale=this.lang;
    }     
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }

    .contenedor{
        position: relative;
        display: inline-block;
        text-align: center;
    }
    
    .texto-centrado{
        position: absolute;
        top: 50%;
        left: 40%;
        transform: translate(-40%, -45%);
    }  

    .texto-centrado-else{
        position: absolute;
        top: 50%;
        left: 40%;
        transform: translate(-45%, -45%);
    }   

</style>